import { useContext, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FormProvider, Resolver, useForm } from "react-hook-form";
import { NewDocumentModalViewContext } from "../../../../Shared/NewDocumentModalView";
import { DocumentModalViewHeader } from "../../../../Shared/DocumentModalViewHeader";
import { NFLookupInput } from "../../../../Shared/NewForms/NFLookupInput";
import { NFTabs } from "../../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../../Shared/NewForms/NFTabContainer";
import { importFromExcel, saveObjectToExcel } from "../../../../../helpers/SaveObjectToExcel";
import { AppEntities } from "../../../../../config/entities";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../../helpers/DocumentHelper";
import ExpenseBanksDetailSkeleton from "./ExpenseBanksDetailSkeleton";
import { EnumHelper } from "../../../../../helpers/EnumHelper";
import ExpenseBanksDetailAdditional from "./ExpenseBanksDetailAdditional";
import ExpenseBanksPaymentToVendorDetail from "../OperationTypesDetailsViews/ExpenseBanksPaymentToVendorDetail";
import ExpenseBanksPaymentToAdvanceHolderDetail from "../OperationTypesDetailsViews/ExpenseBanksPaymentToAdvanceHolderDetail";
import ExpenseBanksCustomsFeeDetail from "../OperationTypesDetailsViews/ExpenseBanksCustomsFeeDetail";
import ExpenseBanksDetailPayrolPaymentDetail from "../OperationTypesDetailsViews/ExpenseBanksDetailPayrolPaymentDetail";
import ExpenseBankCashTransferDetail from "../OperationTypesDetailsViews/ExpenseBankCashTransferDetail";
import ExpenseBanksCashWithDrowal from "../OperationTypesDetailsViews/ExpenseBanksCashWithDrowal";
import ExpenseBanksRepaymentOfLoansDetail from "../OperationTypesDetailsViews/ExpenseBanksRepaymentOfLoansDetail";
import ExpenseBankTransferToDepositDetail from "../OperationTypesDetailsViews/ExpenseBankTransferToDepositDetail";
import ExpenseBanksLoanToCounterPartyDetail from "../OperationTypesDetailsViews/ExpenseBanksLoanToCounterPartyDetail";
import ExpenseBanksLoanToEmployeeDetail from "../OperationTypesDetailsViews/ExpenseBanksLoanToEmployeeDetail";
import ExpenseBanksCurrencyConversionDetail from "../OperationTypesDetailsViews/ExpenseBanksCurrencyConversionDetail";
import ExpenseBanksOtherExpensesDetail from "../OperationTypesDetailsViews/ExpenseBanksOtherExpensesDetail";
import ExpenseBanksRefundToCustomerDetail from "../OperationTypesDetailsViews/ExpenseBanksRefundToCustomerDetail";
import ExpenseBanksInterCompanyTransferDetail from "../OperationTypesDetailsViews/ExpenseBanksInterCompanyTransferDetail";
import { useTranslation } from "react-i18next";
import ExpenseBanksDetailPayments from "./ExpenseBanksDetailPayments";
import { ExpenseBanksDetailFooter } from "./ExpenseBanksDetailFooter";
import DocumentDetailViewToolbar from "../../../../Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "../../../../Shared/DetailViews/DetailViewPostButton";
import DetailViewSaveButton from "../../../../Shared/DetailViews/DetailViewSaveButton";
import DetailViewCancelButton from "../../../../Shared/DetailViewCancelButton";
import DetailViewToolbarMoreActions from "../../../../Shared/DetailViews/DetailViewToolbarMoreActions";
import { IExpenseBanksModel } from "../models/IExpenseBanksModel";
import { useFetchExpenseBankPayments } from "../hooks/fetchDocument";

interface IProps {
  id?:string;
}

export const ExpenseBanksDetail = ({ id}: IProps) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Expense Banks");
  const [selectedOpType, setSelectedOpType] = useState(0);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isValid },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<IExpenseBanksModel>({
    mode: "onTouched"
  });;

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;
  const { t } = useTranslation();

  const { isDocumentLoading, documentModel, postDocument, cancelDocument, updateDocument } = useFetchExpenseBankPayments({ documentId: id });

  useEffect(() => {
    if (documentModel) {
      reset(documentModel);
    }
  }, [documentModel]);

  useEffect(() => {
    if (formState.isDirty) {
      console.log("formState.isDirty", formState.isDirty);
      updateDocument(getValues());
    }
  }, [formState.isDirty]);

  const handlePost = async () => {
    await postDocument();
  };

  const handleCancel = async () => {
    await cancelDocument();
  };
  // const exportToExcel = () => {
  //   const data = {
  //     ...model
  //   };
  //   const documentInfo = {
  //     title: AppEntities.ExpenseBankPayments.title,
  //     number: model.documentNumber,
  //     date: model.documentDate
  //   };
  //   saveObjectToExcel(data, documentInfo);
  // };

  // const handleUploadFile = (file: File) => {
  //   importFromExcel(file, (data: any) => {
  //     reset(data);
  //   });
  // };
  const operationType = watch("operationType");

  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Additional"} />
        <NFTab title={"Payments"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        {/* <DocumentModalViewHeader
          onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))}
          onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))}
          onClose={closeHandler}
          onCancel={cancelHandler}
          handleUploadFile={handleUploadFile}
          exportToExcel={exportToExcel}
          fileName={fileName}
          setFileName={setFileName}
        /> */}
         {/* <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))} />
          <DetailViewSaveButton onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))} />
          <DetailViewCancelButton onCancel={cancelHandler} />
          <DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel} fileName={fileName} setFileName={setFileName} />
        </DocumentDetailViewToolbar> */}
        <DocumentDetailViewToolbar>
            <DetailViewPostButton onPost={handlePost} />
            <DetailViewCancelButton onCancel={handleCancel} />
         
          </DocumentDetailViewToolbar>

        <Col sm={6}>
          <NFLookupInput title={"Operation type"} fieldName={"operationType"} items={EnumHelper.GetOutgoingBankPaymentType()} />
        </Col>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <ExpenseBanksDetailAdditional />
        </NFTabContainer>
        <NFTabContainer index={0} currentIndex={tabIndex}>
          {operationType === 0 && <ExpenseBanksPaymentToVendorDetail />}
          {operationType === 1 && <ExpenseBanksPaymentToAdvanceHolderDetail />}
          {operationType === 2 && <ExpenseBanksCustomsFeeDetail />}
          {operationType === 3 && <ExpenseBanksDetailPayrolPaymentDetail />}
          {operationType === 4 && <ExpenseBankCashTransferDetail />}
          {operationType === 5 && <ExpenseBanksCashWithDrowal />}
          {operationType === 6 && <ExpenseBanksRepaymentOfLoansDetail />}
          {operationType === 7 && <ExpenseBankTransferToDepositDetail />}
          {operationType === 8 && <ExpenseBanksLoanToCounterPartyDetail />}
          {operationType === 9 && <ExpenseBanksLoanToEmployeeDetail />}
          {operationType === 10 && <ExpenseBanksCurrencyConversionDetail />}
          {operationType === 11 && <ExpenseBanksOtherExpensesDetail />}
          {operationType === 12 && <ExpenseBanksRefundToCustomerDetail />}
          {operationType === 13 && <ExpenseBanksInterCompanyTransferDetail />}
        </NFTabContainer>
        <NFTabContainer index={2} currentIndex={tabIndex}>
          <ExpenseBanksDetailPayments />
        </NFTabContainer>
      </div>
      <ExpenseBanksDetailFooter />
    </FormProvider>
  );
};
